import {
  Button,
  H3,
  Modal,
  P,
  PropsModal,
  lightTheme,
  pauseImage,
} from '@vgrubs/components';

export const PausedItemModal = ({
  pausedModal,
  closeModal,
}: PropsModal & {
  pausedModal: boolean;
}) => {
  return (
    <Modal
      isOpen={pausedModal}
      closeModal={closeModal}
      logo={false}
      image={pauseImage}
    >
      <H3 $mb="24" $color={lightTheme.primary}>
        Item is paused!
      </H3>
      <P $mb="40">If you want to unpause item tap on resume button.</P>

      <Button $selected $w="100%" $mb="8">
        Resume
      </Button>

      <Button $selected $w="100%" $gray>
        Cancel
      </Button>
    </Modal>
  );
};
